module.exports = __webpack_public_path__ + "img/fi-rr-caret-right.8bcb2b1d.svg";